module.exports = __webpack_public_path__ + "img/2.6_About-Us_Key-Partner_5_SQCE.89a8eb41c1872b1bf291bed9fa9ce073.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.6_About-Us_Key-Partner_5_SQCE.png
// module id = 782
// module chunks = 0